import './jquery-ui.min.js'
import DOMPurify from 'dompurify';// 引入对HTML消毒插件
import $ from 'jquery' //引用jquery
import 'select2' // 引用下拉菜单插件
import WarrantTermshtml2canvas from 'html2canvas' // 转为图片
import WarrantTermsprintJS from 'print-js' // 打印
import disableScroll from 'disable-scroll'
import { blackScholes } from './black-scholes'
import router from '../../router'
// 引用I18n
import Vue from 'vue'
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

function loadLocaleMessages() {
    const locales = require.context('../../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}

const i18n = new VueI18n({
    locale: localStorage.getItem('Language') == null ? 'id' : localStorage.getItem('Language') == 1 ? 'en' : 'id', // 设置默认语言环境
    fallbackLocale: 'en', // 设置备选语言环境
    messages: loadLocaleMessages() // 加载语言环境信息
});

let tooltips = {}

$.ajax({
    type: "GET",
    url: process.env.VUE_APP_API + "GetAllDisclaimer",
    data: { lang: localStorage.getItem('Language') || 1 },
    dataType: "json",
    success: (res) => {
        if (res.status === "SUCCESS") {

            tooltips = res.tooltips[0]
        }
    },
    error: function (error) {
        console.log(error);
    }
});


export default {
    // 原本的公共js
    OriginalManuscriptJS: function () {
        if ($(".nav").hasClass("nav-tabs") == true) {
            var $navTabs = $('.nav-tabs');

            // Add shadows on load based on initial scroll position
            updateShadows();

            // Attach scroll event listener
            $navTabs.on('scroll', function () {
                updateShadows();
            });

            function updateShadows() {
                // Check scroll positions
                var scrollLeft = $navTabs.scrollLeft();
                var scrollWidth = $navTabs[0].scrollWidth;
                var clientWidth = $navTabs[0].clientWidth;

                // Add or remove left shadow class
                if (scrollLeft > 0) {
                    $navTabs.addClass('left-shadow');
                } else {
                    $navTabs.removeClass('left-shadow');
                }

                // Add or remove right shadow class
                if (scrollLeft + clientWidth < scrollWidth) {
                    $navTabs.addClass('right-shadow');
                } else {
                    $navTabs.removeClass('right-shadow');
                }
            }
        }


        if ($(".nav").hasClass("nav-tabs") == true) {
            var $navTabs = $('.nav-tabs');
            // Attach click event listener to all anchor tags
            $navTabs.find('a.nav-link').on('click', function (e) {
                e.preventDefault(); // Prevent default anchor behavior

                var $this = $(this); // Current clicked anchor
                var itemWidth = $this.outerWidth(); // Width of the clicked item
                var itemOffset = $this.position().left; // Offset of the clicked item from the left of parent
                var containerWidth = $navTabs.outerWidth(); // Width of the scroll container
                var scrollLeft = $navTabs.scrollLeft(); // Current scroll position
                var scrollWidth = $navTabs[0].scrollWidth; // Total scrollable width

                // Calculate the target scroll position to center the clicked item
                var targetScroll = scrollLeft + itemOffset - (containerWidth / 2) + (itemWidth / 2);

                // Ensure target scroll position does not exceed bounds
                if (targetScroll < 0) {
                    targetScroll = 0; // Don't scroll past the start
                } else if (targetScroll > scrollWidth - containerWidth) {
                    targetScroll = scrollWidth - containerWidth; // Don't scroll past the end
                }

                // Smoothly scroll to the target position
                $navTabs.animate({ scrollLeft: targetScroll }, 300); // Adjust the animation speed as needed
            });
        }


    },
    // 监听滚动条
    Scroll: function () {
        $(window).scroll(function () {
            // $('html').addClass('sticky');


            var height = $(window).scrollTop();

            if ($('.Insightsbanner').length > 0) {
                // If the 'Insightsbanner' class is found, apply sticky at 20px scroll
                if (height > 5) {
                    $('html').addClass('sticky');
                } else {
                    $('html').removeClass('sticky');
                }
            } else {
                // If 'Insightsbanner' is not found, use the header sticky logic
                const d = document.getElementById("headersticky");
                const topPos = d.offsetTop - 400;
                if (height > topPos) {
                    $('html').addClass('sticky');
                } else {
                    $('html').removeClass('sticky');
                }
                //console.log(d.offsetTop);
                if (height == 0) {
                    $('html').removeClass('sticky');
                }
            }

            if (jQuery("#myTab").length >= 1) {
                const r = document.getElementById("headersticky");
                if (height > (r.offsetTop - 20)) {
                    $('html').addClass('stickytab');
                } else {
                    $('html').removeClass('stickytab');
                }
            }

            if (jQuery('#insightstext').length >= 1) {

                var note = document.getElementById("insightstext");
                var screenPosition = note.getBoundingClientRect();
                var topPos = screenPosition.top;
                if (topPos <= 0) {
                    $('body').addClass('blogiconshow');
                } else {
                    $('body').removeClass('blogiconshow');
                }
            }

        });
    },
    //  监听屏幕宽度
    Resize: function () {
        if ($(window).width() < 768) {
            $('.megaheader .tab-pane').removeClass('show');
            $('.megaheader .tab-pane').removeClass('active');
            $('.megaheader ul li > a').removeClass('active');
        }
        $(window).resize(function () {
            if ($(window).width() < 768) {
                $('.megaheader .tab-pane').removeClass('show');
                $('.megaheader .tab-pane').removeClass('active');
                $('.megaheader ul li > a').removeClass('active');
            }
        });
    },

    //   /**
    // * 将数值四舍五入后格式化.
    // * @param num 数值(Number或者String)
    // * @param cent 要保留的小数位(Number)
    // * @param isThousand 是否需要千分位 0:不需要,1:需要(数值类型);
    // * @return 格式的字符串,如'1,234,567.45'
    // * @type String
    // */
    /** *yyyy-mm-dd 00:00:00 ==> dd JAN yy****/
    en_mon_arr: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    en_mon_arr1: {
        Jan: '01',
        Feb: '02',
        Mar: '03',
        Apr: '04',
        May: '05',
        Jun: '06',
        Jul: '07',
        Aug: '08',
        Sep: '09',
        Oct: '10',
        Nov: '11',
        Dec: '12'
    },
    /** ************** day / days ***************/
    formatdays(date, d) {
        if (date <= 1) {
            return date + ' day'
        } else if (date > 1) {
            return date + ' ' + d
        } else {
            return '-'
        }
    },
    /** ************** 转为千位值 ***************/
    kilobitNumber(num) {
        if (parseInt(num).toString().length >= 4) {
            return this.FormatNumber(num, 3, 1)
        } else {
            return num
        }
    },
    /** ******* >1 保留5位   **********/
    fiveNum(num) {
        if (Number(num).toString().length > 5) {
            return ((Number(num) / 100000).toFixed(4)) * 10000;
        } else {
            return num
        }

    },
    /** ******* 货币改动 如果是MYR也返回RM  **********/
    curreryRetrun(currery) {
        if (currery !== undefined) {
            if (currery === 'MYR') {
                return 'RM'
            } else {
                return currery
            }
        } else {
            return ' '
        }
    },
    FormatNumber: function (num, cent, isThousand) {
        var sign, cents
        if (num == '-' || num == undefined) {
            return '-'
        }
        num = num.toString().replace(/\$|\,/g, '')
        // 检查传入数值为数值类型
        if (isNaN(num)) {
            num = '0'
        }
        // 获取符号(正/负数)
        sign = num == (num = Math.abs(num))
        num = Math.floor(num * Math.pow(10, cent) + 0.50000000001) // 把指定的小数位先转换成整数.多余的小数位四舍五入
        cents = num % Math.pow(10, cent) // 求出小数位数值
        num = Math.floor(num / Math.pow(10, cent)).toString() // 求出整数位数值
        cents = cents.toString() // 把小数位转换成字符串,以便求小数位长度
        // 补足小数位到指定的位数
        while (cents.length < cent) {
            cents = '0' + cents
        }
        if (isThousand) {
            // 对整数部分进行千分位格式化.
            for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
                num =
                    num.substring(0, num.length - (4 * i + 3)) +
                    ',' +
                    num.substring(num.length - (4 * i + 3))
            }
        }
        if (cent > 0) {
            return (sign ? '' : '-') + num + '.' + cents
        } else {
            return (sign ? '' : '-') + num
        }
    },
    HSINoDot(ric, num, num1) {
        if (ric == '.HSI') {
            return this.FormatNumber(num, 0, num1)
        } else {
            return this.FormatNumber(num, 0, num1)
        }
    },
    /** *yyyy-mm-dd 00:00:00 ==> dd JAN yy****/
    en_mon_arr: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    en_mon_arr1: {
        Jan: '01',
        Feb: '02',
        Mar: '03',
        Apr: '04',
        May: '05',
        Jun: '06',
        Jul: '07',
        Aug: '08',
        Sep: '09',
        Oct: '10',
        Nov: '11',
        Dec: '12'
    },
    formatDate(data) {
        var date =
            data.substring(8, 10) +
            ' ' +
            this.en_mon_arr[Number(data.substring(5, 7)) - 1] +
            ' ' +
            data.substring(0, 4)
        return date
    },
    /** ************** 转换为自己时区 ***************/
    changeToLocalTime(time) {


        if (time) {
            time = `${time.split(' ')[0].replace('-', '/')} ${time.split(' ')[1]}`
        }
        var dateMilliseconds = new Date(time).getTime()
        var timezonemillsecond = -new Date().getTimezoneOffset() * 60000
        dateMilliseconds = dateMilliseconds + timezonemillsecond
        return new Date(dateMilliseconds)
    },
    /** ************** 转换为自己时区 ***************/
    changeToLocalTime1(time) {

        if (time) {
            if (time.indexOf('/') < 0) {

                let data = new Date(time)
                time = `${data.getDate() < 10 ? `0${data.getDate()}` : data.getDate()}/${this.en_mon_arr1[data.toString().split(' ')[1]]}/${data.getFullYear()}`
            }
        }

        return time
    },
    Month: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    Months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ],
    TimeCycle: function (Time, num) {
        if (Time == ' ')
            return "";

        const date = new Date(Time)
        let D = date.getDate()
        let M = num == 0 ? this.Month[date.getMonth()] : this.Months[date.getMonth()]
        let Y = date.getFullYear()

        return num == 0 ? `${M} ${D >= 10 ? D : '0' + D}, ${Y}` : `${D >= 10 ? D : '0' + D} ${M} ${Y}`
    },
    // 对html消毒
    DOMPurify: function (HTML) {
        return DOMPurify.sanitize(HTML)
    },
    // 下拉菜单的使用
    Select2: function (el) {
        $(el).select2({
            minimumResultsForSearch: -1,
            templateResult: (opt) => {
                if (!opt.id) {
                    return opt.text;
                }
                let optimage = $(opt.element).attr('data-image');
                if (!optimage) {
                    return opt.text;
                } else {
                    var $opt = $(
                        `<span><img src="${optimage}" width="60px" alt="Flag" />${opt.text}</span>`
                    );
                    return $opt;
                }
            },
            templateSelection: (opt) => {
                if (!opt.id) {
                    return opt.text;
                }
                let optimage = $(opt.element).attr('data-image');

                if (!optimage) {
                    return opt.text;
                } else {
                    var $opt = $(
                        `<span><img src="${optimage}" width="60px" alt="Flag" />${opt.text}</span>`
                    );
                    return $opt;
                }
            }
        });




    },
    // 打印页面
    Print: function (box) {
        window.scrollTo(0, 0)
        disableScroll.on()
        WarrantTermshtml2canvas(box, {
            backgroundColor: '#ffffff',
            useCORS: true,
            height: document.body.scrollHeight,
            width: document.body.scrollWidth
        }).then((canvas) => {
            const url = canvas.toDataURL('image/png')
            this.img = url
            // 打印图片
            WarrantTermsprintJS({
                printable: url,
                type: 'image',
                documentTitle: '',
                onLoadingStart: function () {
                    disableScroll.off()
                }
            })
        })
    },
    // 下载之后的名字
    export_name(name) {
        const day = new Date()
        return `${name}_${day.getFullYear()}${day.getMonth() + 1}${day.getDate()}`
    },
    /** **********table to excel**************/
    export_table(selector, name, vif) {
        if (document.querySelectorAll(selector).length == 0) {
            alert('Selector "' + selector + '" not exists!')
            return false
        }
        // this.get_table_data(selector)
        this.export_csv(this.get_table_data(selector, vif), name)
    },
    export_csv(data, name) {

        if (window.navigator.msSaveOrOpenBlob) {
            // ie
            var blob = new Blob([decodeURIComponent(encodeURI(data))], {
                type: 'text/csv;charset=utf-8;'
            })
            navigator.msSaveBlob(blob, name + '.csv' || 'temp.csv')
        } else {
            // “\ufeff” BOM头
            console.log(encodeURIComponent(data));

            var uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(data)
            var downloadLink = document.createElement('a')
            downloadLink.href = uri
            downloadLink.download = name + '.csv' || 'temp.csv'
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
        }
    },
    get_table_data(selector, vif) {
        var data = ''
        $.each(document.querySelectorAll(selector + ' tr'), function (t, v) {
            var tmp = []
            if (vif) {
                $.each(v.querySelectorAll('th,td'), function (e, i) {
                    tmp.push(i.innerText.replace(/\n/g, '').replace(/,/g, ''))
                })
                data += tmp.join(',') + '\n'
            } else {
                if (t != 1) {
                    $.each(v.querySelectorAll('th,td'), function (e, i) {
                        tmp.push(i.innerText.replace(/\n/g, '').replace(/,/g, ''))
                    })
                    data += tmp.join(',') + '\n'
                }
            }


        })
        // data = `${data.split(',')[1]}\n${data}`
        return data
    },
    // 搜索框菜单显示
    SearchShow: function (box) {
        $(box).find('.SearchUl').toggle()
        $(box).parent().siblings().find('.SearchUl').hide()

        if ($(box).find('.SearchInput').is(":focus")) {
            $(box).find('.SearchInput').val('')
        }
    },
    PromptEnter: function (box, name) {
        let HTMLtext = ``
        if (name == 'Delta') {
            HTMLtext = `<span class="DeltaHint"><strong>Delta: </strong> ${tooltips['Delta']}</span>`
        }
        if (name == i18n.t('alikeimpliedv')) {
            HTMLtext = `<span class="DeltaHint"><strong>${i18n.t('alikeimpliedv')}: </strong> ${i18n.t("inttext2")}</span>`
        }
        if (name == i18n.t('alikepremium')) {
            HTMLtext = `<span class="DeltaHint"><strong>${i18n.t('alikepremium')}: </strong> ${tooltips['Premium']}</span>`
        }
        if (name == i18n.t('alikesensitivityn')) {
            HTMLtext = `<span class="DeltaHint"><strong>${i18n.t('alikesensitivityn')}: </strong> ${tooltips['Sensitivity']}</span>`
        }
        if (name == i18n.t('alikeeffectiveg')) {
            HTMLtext = `<span class="DeltaHint"><strong>${i18n.t('alikeeffectiveg')}: </strong> ${i18n.t("inttext5")}</span>`
        }
        if (name == 'Theta') {
            HTMLtext = `<span class="DeltaHint"><strong>Theta: </strong> ${tooltips['Theta']}</span>`
        }
        if (name == i18n.t('alikemoneyness')) {
            HTMLtext = `<span class="DeltaHint"><strong>${i18n.t('alikemoneyness')}: </strong> ${tooltips['Moneyness']}</span>`
        }
        if (name == 'Breakeven Point') {
            HTMLtext = `<span class="DeltaHint"><strong>Breakeven Point: </strong> ${tooltips['Breakeven_Point']}</span>`
        }
        $(`.${box}`).prepend(HTMLtext)
    },
    PromptLeave: function () {
        $(`.DeltaHint`).remove()
    },
    toTerms: function (dsplay_nmll) {
        let Routes = router.resolve({
            name: 'WarrantDetail',
            query: { dsplay_nmll: dsplay_nmll }
        })
        location.href = Routes.href;
    },
    DetermineNullValue: function (data) {
        return data ? true : false
    },
    // 计算
    blackScholes: blackScholes,
}